import React, {Component} from 'react'
import {Query} from 'react-apollo'

import Error from '../../base/Error'
import Loading from '../../base/Loading'
import GoodListController from './controller'
import goodsGql from './goods.gql'

const NUM_OF_PRELOAD_GOODS = 10
const MAX_NUM_OF_GOODS = 5000

const GoodListWithData = ({activeCatalogType, preloadCategoryId, sort, ...otherProps}) => <Query
  query={goodsGql}
  variables={{
    catalogTypeName: activeCatalogType.name,
    categoryId: preloadCategoryId,
    sort: sort,
    offset: 0,
    limit: NUM_OF_PRELOAD_GOODS
  }}
>
  {({loading, error, data, fetchMore}) => {
    if (loading) return <Loading noLeftPadding/>
    if (error) return <Error noLeftPadding/>

    const loadAllGoods = () => {
      fetchMore({
        variables: {
          categoryId: null,
          offset: 0,
          limit: MAX_NUM_OF_GOODS
        },
        updateQuery: (prev, {fetchMoreResult}) => {
          if (!fetchMoreResult) return prev
          return {...prev, goods: fetchMoreResult.goods}
        }
      })
    }

    if (typeof window !== 'undefined' && data.goods.length <= NUM_OF_PRELOAD_GOODS) loadAllGoods()

    return <GoodListController
      {...otherProps}
      activeCatalogType={activeCatalogType}
      goods={data.goods}
    />
  }}
</Query>

/*
  Идея в следующем. Когда страница загружается в первый раз, нужно отрисовать ее как можно быстрее, поэтому
  рендерим небольшое количество товаров, а когда подтянутся скрипты, они догрузят остальные для всех категорий,
  чтобы быстро по ним переключаться, чтобы работал поиск и т.д.

  Но если мы передадим запрошенную категорию в gql-запрос, то при переключении категорий запрос будет выполняться
  повторно. Поэтому нам нужно задать категорию одиин раз (отдельный параметр preloadCategoryId),
  только при инициализации, а точнее, при инициализации или смене типа каталога. Этим и занимается эта прослойка.
*/
class GoodListPreloadController extends Component {
  render() {
    // если с прошлого раза изменился catalogType, то сбрасываем предыдущее значение preloadCategoryId
    if (this.prevCatalogType !== this.props.activeCatalogType) { this.preloadCategoryId = undefined }
    this.prevCatalogType = this.props.activeCatalogType

    // если preloadCategoryId еще не задан, то используем текущую активную категорию
    if (typeof this.preloadCategoryId === 'undefined') {
      const activeCategory = this.props.activeCategory
      this.preloadCategoryId = activeCategory ? activeCategory.id : null
    }

    return <GoodListWithData {...this.props} preloadCategoryId={this.preloadCategoryId} />
  }
}

export default GoodListPreloadController
